// src/app/services/ailike-jobs.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Job } from '../Models/job-like-job.model';

@Injectable({
  providedIn: 'root'
})
export class JobToJobListService {
  constructor(private http: HttpClient) {}

  getJobs(input: any): Observable<Job[]> {
    return this.http.post<Job[]>('/TgNewUI/Search/Ajax/AILikeJobs', input);
  }
  fetchJobs(input: any): Observable<Job[]> {
  return this.http.post<Job[]>('/TgNewUI/Search/Ajax/AILikeJobs', input);
}
}
